import React, { Fragment } from 'react';

import withAuthServerSideProps from '@/libs/auth';
import { PageLayout, PagePath } from '@/layouts/shared';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import MetaTag from '@/components/ui/MetaTag';
import { Image, Link } from '@/components';
import Title from '@/components/ui/Title';
const ReferralPage = () => {
  return (
    <Fragment>
      <MetaTag title="Giới thiệu An Thư - Landing page" description="Giới thiệu An Thư  - Landing page" />
      <div className="tw-w-screen tw-min-h-screen tw-h-max tw-bg-no-repeat">
        <div
          className="tw-flex tw-items-center tw-justify-center tw-bg-white tw-sticky tw-top-0 tw-left-0 tw-right-0 tw-bg-cover tw-bg-top tw-bg-no-repeat tw-py-3 md:tw-py-5 tw-border-b border-color-custom-header tw-z-50"
          style={{
            backgroundImage: `url('/header.svg')`,
          }}
        >
          <Link url="/">
            <object
              className="tw-h-12 md:tw-h-16 lg:tw-h-20 tw-pointer-events-none tw-cursor-pointer"
              type="image/svg+xml"
              data="/logo-has-bg.svg"
            />
          </Link>
        </div>
        <div className="tw-relative tw-w-full tw-pb-70-percent md:tw-pb-35-percent">
          <Link
            className="tw-text-sm md:tw-text-lg xl:tw-text-xl tw-uppercase !tw-text-white tw-font-semibold tw-px-6 md:tw-px-10 tw-py-3 xl:tw-py-5 tw-bg-primary-main tw-rounded-5 md:tw-rounded-lg tw-z-10 tw-absolute tw-left-1/2 tw--translate-x-1/2 tw-bottom-8 md:tw-bottom-12 lg:tw-bottom-16 xl:tw-bottom-24 2xl:tw-bottom-36"
            url={{ pathname: PagePath.AccountProfilePage }}
          >
            THAM GIA NGAY
          </Link>
          <Image
            className="tw-h-full tw-w-full tw-hidden md:tw-block  !tw-absolute tw-left-0 tw-top-0"
            src="/banner-landingpage.jpg"
            alt="banner"
          />
          <Image
            className="tw-h-full tw-w-full tw-block md:tw-hidden  !tw-absolute tw-left-0 tw-top-0"
            src="/banner-mobile.jpg"
            alt="banner"
          />
        </div>
        <div className="tw-py-10 container tw-m-auto">
          <div className="referral-landing-title tw-relative tw-flex tw-justify-center">
            <div className="tw-flex tw-bg-white tw-w-max tw-items-center tw-justify-center tw-px-5 tw-z-10">
              <Image src="/ico_star.svg" alt="star" className="tw-h-5 tw-w-5" />
              <h2
                className={`tw-block tw-px-4 tw-w-48 lg:tw-w-max tw-text-center !tw-text-xl md:!tw-text-3xl tw-uppercase tw-text-primary-main tw-font-semibold `}
              >
                điều kiện chương trình
              </h2>
              <Image src="/ico_star.svg" alt="star" className="tw-h-5 tw-w-5" />
            </div>
          </div>
          <div className="tw-mt-10">
            <div className="tw-flex tw-flex-col lg:tw-flex-row lg:tw-gap-x-14">
              <ul className="tw-flex-1 tw-list-disc tw-text-sm md:tw-text-lg tw-text-secondary-70 tw-pl-4 md:tw-pl-10">
                <li className="tw-leading-7">
                  <span className="tw-font-bold tw-underline">Thời gian:</span> 24-25/12/2022
                </li>
                <li className="tw-leading-7">
                  <span className="tw-font-bold tw-underline">Người tham gia:</span> Người giới thiệu & người được giới
                  thiệu
                </li>
                <li className="tw-leading-7">
                  <span className="tw-font-bold tw-underline">Người giới thiệu:</span>
                  <br /> Người <b>đã có tài khoản</b> trên ứng dụng An Thu giới thiệu đến người thân, bạn bè tải app,
                  đăng ký sử dụng và mua hàng thành công{' '}
                  <b className="tw-text-primary-main">sẽ nhận được 3.00 ATD (tương đương 300,000 đ)</b> vào tài khoản.
                </li>
                <li className="tw-leading-7">
                  <span className="tw-font-bold tw-underline">Người được giới thiệu:</span>
                  <br />
                  Tải app, tạo tài khoản & hoàn thành đơn hàng đầu tiên{' '}
                  <b className="tw-text-primary-main">sẽ nhận được 12.00 ATD (tương đương 1,200,000 đ).</b>
                </li>
              </ul>
              <div className="tw-text-center">
                <Image
                  src="/gift-referral.png"
                  alt="gift image"
                  className="tw-w-64 tw-h-64 md:tw-w-72 md:tw-h-72 lg:tw-w-80 lg:tw-h-80"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className="tw-py-10"
          style={{
            background:
              'linear-gradient(251.98deg, rgba(16, 102, 87, 0.09) 34.86%, rgba(16, 102, 87, 0.09) 34.86%, rgba(255, 113, 13, 0.09) 114.78%)',
          }}
        >
          <div className="container">
            <div className="tw-relative tw-flex tw-justify-center">
              <Title
                className="!tw-text-xl md:!tw-text-3xl __title-step"
                cs="!tw-w-40 tw-text-center lg:!tw-w-max"
                name="các bước tham gia"
              ></Title>
            </div>
            <div className="tw-mt-10 md:tw-px-10">
              <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 lg:tw-gap-x-20">
                <div>
                  <div className="tw-leading-7 tw-text-sm md:tw-text-lg tw-flex">
                    <span className="tw-w-6 tw-h-6 md:tw-w-8 md:tw-h-8 tw-bg-primary-main tw-text-white tw-flex tw-items-center tw-rounded-full tw-justify-center tw-mr-2 ">
                      1.
                    </span>
                    <span className="tw-flex-1 md:tw-h-14 tw-text-secondary-70">
                      Vào trang cá nhân, chọn <b>Giới thiệu An Thư</b>
                    </span>
                  </div>
                  <div className="tw-pt-8 md:tw-pt-10 tw-flex tw-justify-center lg:tw-justify-start lg:tw-pl-10">
                    <object
                      className="tw-w-80 tw-h-60 tw-pointer-events-none tw-cursor-pointer"
                      type="image/svg+xml"
                      data="/ref-step-1.svg"
                    />
                    {/* <Image className="tw-w-80 tw-h-60" alt="ref-step-1" src="/ref-step-1.svg"></Image> */}
                  </div>
                </div>
                <div className="tw-mt-4 lg:tw-mt-0">
                  <div className="tw-leading-7 tw-text-sm md:tw-text-lg tw-flex">
                    <span className="tw-w-6 tw-h-6 md:tw-w-8 md:tw-h-8 tw-bg-primary-main tw-text-white tw-flex tw-items-center tw-rounded-full tw-justify-center tw-mr-2">
                      2.
                    </span>
                    <span className="tw-flex-1 tw-h-14 tw-text-secondary-70">
                      <b>Sao chép mã</b> hoặc <b>sao chép link</b> trang website giới thiệu và{' '}
                      <b>gửi cho người thân, bạn bè.</b>
                    </span>
                  </div>
                  <div className="tw-pt-10 tw-flex tw-justify-center lg:tw-justify-start lg:tw-pl-10">
                    <object
                      className="tw-w-80 tw-h-60 tw-pointer-events-none tw-cursor-pointer"
                      type="image/svg+xml"
                      data="/ref-step-2.svg"
                    />
                  </div>
                </div>
              </div>
              <div className="tw-flex tw-justify-center">
                <Link
                  className="md:tw-text-lg xl:tw-text-xl tw-uppercase !tw-text-white tw-font-semibold tw-mt-10 md:tw-mt-16 tw-px-10 tw-py-3 xl:tw-py-5 tw-bg-primary-main tw-rounded-5 md:tw-rounded-lg"
                  url={{ pathname: PagePath.AccountProfilePage }}
                >
                  Bắt đầu giới thiệu
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="tw-py-10 container tw-m-auto">
          <div className="referral-landing-title tw-relative tw-flex tw-justify-center">
            <div className="tw-flex tw-bg-white tw-w-max tw-items-center tw-justify-center tw-px-5 tw-z-10">
              <Image src="/ico_star.svg" alt="star" className="tw-h-5 tw-w-5" />
              <h2
                className={`tw-block tw-px-4 tw-w-40 tw-text-center lg:tw-w-max tw-text-xl md:tw-text-3xl tw-uppercase tw-text-primary-main tw-font-semibold `}
              >
                Các câu hỏi liên quan
              </h2>
              <Image src="/ico_star.svg" alt="star" className="tw-h-5 tw-w-5" />
            </div>
          </div>
          <div className="tw-mt-10">
            <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 lg:tw-gap-x-14">
              <ul className="tw-flex-1 tw-text-sm md:tw-text-lg tw-text-secondary-70 tw-pl-1 md:tw-pl-10">
                <li className="tw-leading-8">
                  <div className="tw-font-bold">1. Làm thế nào để trở thành Người giới thiệu của AnThu?</div>
                  <p className="tw-italic">
                    Để trở thành Người giới thiệu bạn chỉ cần là người đã có tài khoản tại ứng dụng AnThu.
                  </p>
                </li>
                <li className="tw-leading-8">
                  <div className="tw-font-bold">2. Làm thế nào để hoàn thành một lượt giới thiệu đến bạn bè?</div>
                  <p className="tw-italic">
                    Hướng dẫn bạn bè tải ứng dụng sau đó tạo tài khoản và đăng nhập. Bạn bè của quý khách hoàn thành đơn
                    hàng đầu tiên là đã hoàn thành 1 lượt giới thiệu.
                  </p>
                </li>
                <li className="tw-leading-8">
                  <div className="tw-font-bold">3. Tôi có thể biết những tài khoản đã giới thiệu thành công ở đâu?</div>
                  <p className="tw-italic">
                    Quý khách có thể xem ở phần: <br />
                    a. Vào tab Cá nhân
                    <br />
                    b. Chọn Giới thiệu An Thư
                    <br />
                    c. Bấm Danh sách đã giới thiệu
                  </p>
                </li>
                <li className="tw-leading-8">
                  <div className="tw-font-bold">4. Tôi cần giới thiệu bao nhiêu bạn bè thì được nhận thưởng?</div>
                </li>
              </ul>
              <ul className="tw-flex-1 tw-text-sm md:tw-text-lg tw-text-secondary-70 tw-pl-1 md:tw-pl-10">
                <li className="tw-leading-8">
                  <p className="tw-italic">
                    Chương trình không có quy định số lượng Khách hàng được giới thiệu tối thiểu để nhận thưởng.
                  </p>
                </li>
                <li className="tw-leading-8">
                  <div className="tw-font-bold">5. Tôi nhận được điểm thưởng vào thời gian nào?</div>
                  <p className="tw-italic">
                    Quý khách sẽ nhận được điểm thưởng ngay lập tức khi người được giới thiệu hoàn thành đơn đầu tiên.
                  </p>
                </li>
                <li className="tw-leading-8">
                  <div className="tw-font-bold">6. Tôi sẽ được nhận thưởng qua hình thức nào?</div>
                  <p className="tw-italic">
                    ATD sẽ tự động được cộng vào ví ATD trong tài khoản trên ứng dụng An Thư của quý khách hàng.
                  </p>
                </li>
                <li className="tw-leading-8">
                  <div className="tw-font-bold">7. ATD là gì?</div>
                  <p className="tw-italic">
                    ATD là viết tắt của An Thư Điểm, ATD được phát hành bởi An Thư Diamond Store. ATD dùng để thanh toán
                    và mua sắm trực tuyến trên website anthu.vn hoặc ứng dụng Anthu. ATD không đổi được thành tiền mặt
                    nhưng bạn có thể chuyển tặng cho người khác. Khách hàng cũng có thể mua ATD tại website anthu.vn
                    hoặc ứng dụng Anthu.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className="tw-py-10 lg:tw-py-16 tw-font-semibold tw-text-white tw-bg-top tw-bg-cover tw-text-center"
          style={{
            backgroundImage: 'url(/bg-footer-landingpage.svg)',
          }}
        >
          Copyright © 2022 Blog An Thư. All rights reserved.
        </div>
      </div>
    </Fragment>
  );
};

export const getServerSideProps = withAuthServerSideProps(
  async ({ locale, query }: GetServerSidePropsContext) => {
    return {
      props: {
        layout: PageLayout.Basic,
        ...(await serverSideTranslations(locale as string, ['layout'])),
      },
    };
  },
  { isAntiAuth: false, isPublic: true }
);

export default ReferralPage;
